// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteEnrollmentModel {
    static getAttributeTypeMap() {
        return SiteEnrollmentModel.attributeTypeMap;
    }
}
SiteEnrollmentModel.discriminator = undefined;
SiteEnrollmentModel.additionalProperties = false;
SiteEnrollmentModel.attributeTypeMap = [
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "string"
    },
    {
        "name": "siteType",
        "baseName": "siteType",
        "type": "TCSSiteType"
    },
    {
        "name": "siteCommunicationTypes",
        "baseName": "siteCommunicationTypes",
        "type": "Array<>"
    },
    {
        "name": "siteCommunicationOption",
        "baseName": "siteCommunicationOption",
        "type": "TCSCommunicationOption"
    },
    {
        "name": "sitePayable",
        "baseName": "sitePayable",
        "type": "boolean"
    },
    {
        "name": "aobReceived",
        "baseName": "aobReceived",
        "type": "boolean"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "string"
    },
    {
        "name": "prescriberCommunicationTypes",
        "baseName": "prescriberCommunicationTypes",
        "type": "Array<>"
    },
    {
        "name": "prescriberCommunicationOption",
        "baseName": "prescriberCommunicationOption",
        "type": "TCSCommunicationOption"
    },
];
//# sourceMappingURL=siteEnrollmentModel.js.map